import user from './user'
import meter from './meter'
export default {
	user,
	meter,
	fetch (request, options, payload) {
		var self = this
		return new Promise((resolve, reject) => {
			var mergedOptions = Object.assign({credentials: 'include'}, options)
			if (typeof options.getparams === 'object') {
				request = request + '?' + self.queryBuild(options.getparams)
			}
			fetch(request, mergedOptions)
				.then(r => r.ok ? r : Promise.reject(new Error('Bad status code')))
				.then(r => r.json())
				.then(data => {
					if (data && data.success) {
						return resolve(data)
					} else if (typeof payload.successFalse === 'function') {
						payload.successFalse(data)
					}
					// Promise.reject(new Error('Server marked request as unsuccessful'))
				})
				.catch(reject)
		})
	},
	buildFormData (data) {
		var formDataInstance = new FormData()
		for (var key in data) {
			formDataInstance.append(key, data[key])
		}
		return formDataInstance
	},
	csrfPrepare (data) {
		if (data === null || typeof data !== 'object') {
			return data
		}

		let document = window.document

		var copy = data.constructor()
		for (var attr in data) {
			if (data.hasOwnProperty(attr)) copy[attr] = data[attr]
		}

		let param = document.querySelector("meta[name='csrf-param']").getAttribute('content')
		copy[param] = document.querySelector("meta[name='csrf-token']").getAttribute('content')
		return copy
	},
	queryBuild (obj, prefix) {
		if (obj === null || typeof obj !== 'object') {
			return ''
		}

		var str = []
		var p
		for (p in obj) {
			if (obj.hasOwnProperty(p)) {
				var k = prefix ? prefix + '[' + p + ']' : p
				var v = obj[p]
				str.push((v !== null && typeof v === 'object')
					? this.queryBuild(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent((v !== null) ? v : ''))
			}
		}
		return str.join('&')
	}
}



// WEBPACK FOOTER //
// ./src/api/index.js